import React from "react";

export const getFontFamily = (type) => {
  switch (type) {
    case "Default":
      return "'Inter', sans-serif";

    case "Open Sans":
      return "'Open Sans', sans-serif";

    case "Lato":
      return "'Lato', sans-serif";

    case "Roboto":
      return "'Roboto', sans-serif";

    case "Mono":
      return "'Courier New', monospace";

    case "Serif":
      return "'Times New Roman', serif";

    case "Sans":
      return "Arial, sans-serif";

    case "Poppins":
      return "'Poppins', sans-serif";

    case "Inter":
      return "'Inter', sans-serif";

    default:
      return "'Inter', sans-serif";
  }
};

